import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../styles/FilterPanel.scss";

export interface Props {
  onClick: Function;
  collapsed: boolean;
}

const FilterTitleBar = ({ onClick, collapsed }: Props) => {
  const handleClick = (e: any) => {
    onClick();
  };

  const titleIcon = collapsed ? "plus-circle" : "minus-circle";

  const titleContent = (
    <p className="ds-u-padding-top--2 ds-u-padding-left--2 report-param screenOnly">
      Report Parameters
      <button
        type="button"
        value="collapse"
        aria-label="collapse"
        className="ds-c-button ds-c-button--transparent-inverse ds-u-font-weight--normal ds-u-float--right"
        onClick={handleClick}
      >
        <FontAwesomeIcon
          icon={["fas", titleIcon]}
          className="ds-u-float--right ds-u-margin-left--2"
        />
      </button>
    </p>
  );

  return (
    <div className="ds-u-border--1 ds-u-border--dark ds-u-margin-bottom---1 ds-u-color--white ds-u-fill--primary-darkest filterBoxShadow">
      {titleContent}
    </div>
  );
};

export default FilterTitleBar;
